import { Component, Input, ViewEncapsulation, OnInit, Optional } from '@angular/core';
import { WindowRef } from '@progress/kendo-angular-dialog';
import { LogService } from '../../../log.service';
import { MessageDetails } from "../../message-detail.model";
import { MessageType, HeaderBarMessageHeaderInfo } from '../../message.model';

@Component({
  selector: 'file360-header-bar-message',
  templateUrl: './header-bar-message.component.html',
  styleUrls: ['./header-bar-message.component.scss',
    '../../kendo-overrides.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class HeaderBarMessageComponent implements OnInit {

  /**
   * Header bar information 
   */
  @Input() hbi: HeaderBarMessageHeaderInfo = new HeaderBarMessageHeaderInfo();
  /**
   * Header bar detail information
   */
  @Input() details: MessageDetails = new MessageDetails();

  constructor(@Optional() public windowRef: WindowRef, public logService: LogService) {
  }

  ngOnInit() {
  }

  /**
   * Close the header bar message
   */
  onClose() {
    let msg: string = "HeaderBarMessageComponent : onClose - " + this.hbi.message;
    this.logService.logMessage(msg);
    this.windowRef.close();
  }
  /**
   * Get the ngClass-formatted structure that applies the CSS style name
   * for the message type of this message. 
   */
  get messageClass() {
    return {
      "ot-message-error": this.hbi.messageType == MessageType.Error,
      "ot-message-question": this.hbi.messageType == MessageType.Question,
      "ot-message-warning": this.hbi.messageType == MessageType.Warning,
      "ot-message-confirmation": this.hbi.messageType == MessageType.Confirmation,
      "ot-message-information": this.hbi.messageType == MessageType.Information,
      "ot-message-status": this.hbi.messageType == MessageType.Status
    }
  }
}
